module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-five-bg.02f09ace.png";